export default {"src":"/_next/static/media/robot.b95717e6.svg","height":51,"width":46};